import { toast } from '@/lib/toasts/api'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import AttestationsService from '@/modules/drivers/services/AttestationsService'

/**
 * Pobranie zaznaczonych zaświadczeń (jeden PDF, strona na zaświadczenie).
 * Współdzielone przez pasek akcji tabeli i przycisk "Potwierdź" w modalu.
 */
export const useAttestationsDownload = (companyId: string) => {
  const { tSafe } = useLocalize()
  const { downloadAttestations } = AttestationsService()

  const downloadSelected = async (attestationIds: (string | number)[]) => {
    const ids = attestationIds
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id))

    if (ids.length === 0) return false

    try {
      await downloadAttestations({ attestationIds: ids, companyId })
      toast.info({
        title:
          ids.length > 1
            ? tSafe(
                'attestation.generation-success-many',
                'Zaświadczenia wygenerowane',
              )
            : tSafe(
                'attestation.generation-success',
                'Zaświadczenie wygenerowane',
              ),
        text: tSafe(
          'attestation.generation-confirmation',
          'Plik PDF został pobrany.',
        ),
      })
      return true
    } catch (err: any) {
      const code = err?.code ?? null
      toast.error({
        text: tSafe(
          `errorCode.${code ?? 'ATTESTATION_NOT_GENERATED'}`,
          tSafe(
            'errorCode.ATTESTATION_NOT_GENERATED',
            'Nie udało się wygenerować zaświadczenia.',
          ),
        ),
      })
      console.error('Download attestation failed', err)
      return false
    }
  }

  return { downloadSelected }
}
